import { render } from "./Verovio.vue?vue&type=template&id=7ff2bba1"
import script from "./Verovio.vue?vue&type=script&lang=js"
export * from "./Verovio.vue?vue&type=script&lang=js"

import "./Verovio.vue?vue&type=style&index=0&id=7ff2bba1&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__